module.exports = __webpack_public_path__ + "static/img/bg-ar.de888c82.png";